import React, { useEffect, useState, useMemo } from 'react'
import CommonList from '../../Settings/SettingsViews/CommonList'
import { ContextButton, TextInput } from '@tecuity/granite-ui'
import '../../Settings/SettingsViews/SettingsListView.scss'
import * as api from '../../../requests'
import PayorAccountDetails from './PayorAccountDetails'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'

const frequentPayorLabel = process.env.FREQUENT_PAYOR_LABEL

const PayorAccounts = () => {
  const [allAccounts, setAllAccounts] = useState([])
  const [accountId, setAccountId] = useState(null)
  const [filterText, setFilterText] = useState('')
  const [showBillableFlag, setShowBillableFlag] = useState(false)

  useEffect(() => {
    loadAllAccounts()
    api.GET_APP_SETTING_BY_NAME(
      'FrequentPayorAllowBillableAccounts',
      (setting) => {
        setShowBillableFlag(setting && setting.VALUE === 'true')
      },
      (err) => {
        console.error(err)
        setShowBillableFlag(false)
      }
    )
  }, [])

  const loadAllAccounts = () => {
    api.GET_ALL_FREQUENT_PAYOR_ACCOUNTS((accounts) => {
      console.log(accounts)
      setAllAccounts(
        accounts.map((account) => {
          return {
            Id: account.Id,
            Name: account.Name,
          }
        })
      )
    }, console.error)
  }

  const filteredAccounts = useMemo(() => {
    if (!filterText) return allAccounts
    return allAccounts.filter((account) => account.Name.toLowerCase().includes(filterText.toLowerCase()))
  }, [allAccounts, filterText])

  return (
    <div className="settings-list-view">
      <h2>{`${frequentPayorLabel || `Frequent Payor Accounts`}`}</h2>
      <div className="settings-content">
        <div className="settings-left-column">
          <TextInput
            customCss={`input {border: none}`}
            placeholder="Filter"
            onChange={(e) => setFilterText(e.target.value)}
          />
          <div className="settings-list-wrapper">
            <CommonList
              list={filteredAccounts}
              selectItem={(account) => {
                setAccountId(account.Id)
              }}
              itemTitle={`accounts`}
            />
            <ContextButton variant="secondary" onClick={() => setAccountId(null)}>
              <CrossHeavy />
            </ContextButton>
          </div>
        </div>
        <PayorAccountDetails 
          accountId={accountId} 
          isAdding={accountId ? false : true} 
          onSave={loadAllAccounts}
          showBillableFlag={showBillableFlag}
        />
      </div>
    </div>
  )
}

export default PayorAccounts
